import { Controller, useFormContext } from "react-hook-form";
import { Column } from "../Layout/Layout";
import useTranslations from "../../core/i18n/useTranslations";
import {
  ITreeData,
  CustomDropdown,
} from "../../ui-lib/components/Hierarchy/CustomTreeDropdown/CustomDropdown";

export const SelectOrganization = ({
  disable,
  respondent,
  mandatory = true,
}: {
  disable: boolean;
  respondent: boolean;
  mandatory?: boolean;
}) => {
  const t = useTranslations();
  const {
    formState: { errors },
    control,
    trigger,
    setValue,
  } = useFormContext();
  return (
    <Column>
      <Controller
        name="organizationId"
        control={control}
        rules={{ required: mandatory }}
        render={({ field }) => (
          <CustomDropdown
            selectionMode="single"
            required
            label={
              respondent ? t("Common:organisation") : t("Common:belongs_to")
            }
            placeholder={t("Common:select_organisation")}
            disabled={disable}
            customerFilter={{ customers: field.value?.toString() }}
            onSelectSignle={(selectedOrg?: ITreeData) => {
              setValue(field.name, selectedOrg?.key as number);
              trigger(field.name);
            }}
            validationError={
              errors.organizationId && t("Errors:input_field_required")
            }
            fullWidth
          />
        )}
      />
    </Column>
  );
};
